import React from "react"
import { panels } from "../config/Helpers";
import TagsInput from 'react-tagsinput'
import moment from 'moment';
import 'react-tagsinput/react-tagsinput.css'
import axios from "axios";
import { latest as API_URL, host_app as APP_URL } from "../config/api";
import { firebase_connect } from "../config/firebase/api";
import locale from 'antd/lib/date-picker/locale/en_US';
import { Icon, Radio, message, Drawer, DatePicker, Select, Button, Input } from 'antd';

const postUrlWidgets = API_URL + "reports";

class ReportModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            endOpen: false,
            rows_models: "",
            rows_reports:  "",
            request_loading : {
                window : "hide",
                before : "hide",
                after : "hide"
            },
            interval_days_analysis : {
                status : "hide-panel",
                key : "1 DAY",
                value : 1
            },
            interval_days_send : {
                status : "hide-panel",
                key : "1 DAY",
                value : 1
            },
            panels_report : {
                status : "hide-panel",
                key : "ALL",
                value : 1    
            },
            panels : panels(),
            _report_name_fixed : "",
            dashboards_select : [],
            startValue : new moment(),
            endValue : null,
            tags: [],
            saveBtnState : "",
            shareBtnState : "",
            completeBtnState : "hide",
            moreBtnState : "hide",
            step_active : "1",
            _type_report : "",
            message_email: "",
            notify_email: 0,
            private_url: 0,
            dinamyc_report: 0,
            visible : false,
            availably_days : 1,
            _analysis_interval : 1,
            _allow_export : 0
        }
        this.handleDayClick = this.handleDayClick.bind(this);
        this.setDefaultValues = this.setDefaultValues.bind(this);
    }

    /** Calendar range */

    disabledStartDate = (startValue) => {
        const endValue = this.state.endValue;
        if (!startValue || !endValue) {
          return false;
        }
        return startValue.valueOf() > endValue.valueOf();
      }
    
    disabledEndDate = (endValue) => {
        const startValue = this.state.startValue;
        if (!endValue || !startValue) {
            return false;
        }
        return endValue.valueOf() <= startValue.valueOf();
    }

    onChange = (field, value) => {
        this.setState({
            [field]: value,
        });
    }

    onStartChange = (value) => {
        this.onChange('startValue', value);
    }

    onEndChange = (value) => {
        this.onChange('endValue', value);
    }
    
    handleStartOpenChange = (open) => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    }
    
    handleEndOpenChange = (open) => {
        this.setState({ endOpen: open });
    }

    handleDayClick(day) {
       // this.setState({ datepicker : range });
    }
    handleClick(type) {
        this.setDefaultValues()
        this.props.reportModelState(type)
    }
    handleClickMenu(select) {
        //this.props.hideSelects();
        this.setState((prev)=> {
            const status = prev[select]["status"] === "hide-panel" ? "" : "hide-panel";
            return {
                [select] : {
                    status : status,
                    key : prev[select].key
                }
            }
        })
    }
    setDefaultValues(){
        this.setState({
            request_loading :  {
                window : "hide",
                before : "hide",
                after : "hide"
            },
            rows_models: "",
            rows_reports: "",
            interval_days_analysis : {
                status : "hide-panel",
                key : "1 DAY",
                value : 1
            },
            interval_days_send : {
                status : "hide-panel",
                key : "1 DAY",
                value : 1
            },
            panels_report : {
                status : "hide-panel",
                key : "ALL",
                value : 1    
            },
            dashboards_select : [],
            _report_name_fixed : "",
            startValue : new moment(),
            endValue : null,
            tags: [],
            saveBtnState : "",
            shareBtnState : "",
            completeBtnState : "hide",
            moreBtnState : "hide",
            step_active : "1",
            _type_report : "",
            message_email: "",
            notify_email: 0,
            private_url: 0,
            dinamyc_report: 0,
            availably_days : 1,
            visible : false,
            _analysis_interval : 1,
            _allow_export : 0
        })
    }
    handleClickMenuItem(keyText, valueText, menu) {
        let $self = this;
        switch (menu) {
            case "period_menu":
                this.setState({ 
                    current_period : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.setRangeCustom(valueText))
            break;
            case "views_menu":
                this.setState({ 
                    current_view_review : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;
            case "reservation_chart_menu":
                this.setState({ 
                    current_view_reservation : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;

            case "leadtime_chart_menu":
                this.setState({ 
                    current_view_leadtime : { 
                        key : keyText, value : valueText 
                    } 
                }, () => $self.props.setViewList(valueText))
            break;
            case "status_menu":
                this.setState({
                    current_status : { 
                        key : keyText, value : valueText 
                    } 
                }, () => this.props.setTypeDateQuery(valueText))
            break;
            case "comp_menu":
                this.setState({
                    current_comp : { 
                        key : keyText, value : valueText 
                    } 
                })
            break;
            case "comp_year":
                this.changeDatesByYear('current', valueText)
            break;
            case "comp_past_year":
                this.changeDatesByYear('compare', valueText)
            break;
            case "custom_compare":
                this.setState({
                    current_option_compare : { key : keyText, value : valueText } 
                }, () => {
                    if(valueText === "custom_past_year"){
                        this.setState({ datepicker_compare : '' })
                    }else{
                        this.setState({ datepicker_compare : 'hide' })
                    }
                })
            break;
            case "days":
                var array_elements  = this.state.active_days

                if(array_elements[valueText] === undefined){
                    array_elements[valueText] = { day : keyText, value : valueText }
                }else{
                    delete array_elements[valueText];
                }
                this.setState({
                    active_days : array_elements,
                })
            break;
        }
    }
    setShareModal(data){
        let self = this;
        
        self.setState(() => {
            let params =  {
                step_active : "2",
                shareBtnState : "hide",
                saveBtnState : "hide",
                completeBtnState : "btn-full",
            }
            return params;
        }, function(){
            self.setState(() => {
                let params = {}
                if(data['report_share'] !== undefined && data['report_share'] !== null){
                    params.dashboards_select = data['report_share']['dashboards_select'];
                    params.message_email = data['report_share']['message_email'];
                    params.tags = data['report_share']['emails'];
                    params.availably_days = data['report_share']['availably_days'];
                    params.dinamyc_report = data['report_share']['dinamyc_report'];
                }
                return params
            })
            self.props.app._widgetSidebar.setState({
                _report : {
                    active : false,
                    edit : false,
                    share : true
                }
            }, function(){
                self.props.app.setState({
                    report_context : {
                        _id : data['_id'],
                        status : true,
                        className : 'report-context-share',
                        name : data['name'],
                        //type : data['type'],
                        //notify_email : data['notify_email'],
                        //datepicker : data['datepicker'],
                        days_fixed_report : ['days_fixed_report']
                    }
                })
            })
        })
    }
    activeReport(type, _is_new){
        let self = this;
        
        if(_is_new === true){
            this.setState((prev) => {
                if(prev._type_report !== type){
                    return { _type_report : type}
                }
            })
        }else{
            if(self.props.app._widgetSidebar.state._report.edit === true){
                self.setState({
                    _report_name_fixed : self.props.app.state.report_context.name,
                    _days_fixed_report : self.props.app.state.report_context.days_fixed_report,
                    _analysis_interval : self.props.app.state.report_context.analysis_interval,
                    _type_report : self.props.app.state.report_context.type_report,
                    startValue : new moment(self.props.app.state.report_context.startValue),
                    endValue : new moment(self.props.app.state.report_context.endValue)
                })
            }else{
                self.setState(function(prev){
                    return {
                        tags: [],
                        message_email: "",
                        dashboards_select : [],
                        _report_name_fixed : "",
                        availably_days: 1,
                        dinamyc_report: 1,
                        _days_fixed_report : 7,
                        notify_email : 0,
                        _allow_export : 0,
                        _analysis_interval : 1,
                        _type_report : "FIXED",
                        startValue : null,
                        endValue : null
                    }
                })
            }
        }
    }

    setPrivateUrl(e) {
        this.setState((prev) => {
            if (prev.private_url !== e.target.value) {
                return { private_url: e.target.value }
            }
        })
    }
    setDinamycReport(notify) {
        this.setState((prev) => {
            if (prev.dinamyc_report !== notify) {
                return { dinamyc_report: notify }
            }
        })
    }
    skipStep(){
        this.handleClick("reports-new")
        this.completeReport({ _msg : 'The report has been completed.'});
    }
    actionReport(action){

        if(action !== "_complete_share"){
            const report_name_fixed = this.state._report_name_fixed;
            const days_fixed_report = this.state._days_fixed_report;
            const _validate = (report_name_fixed !== "");

            if(_validate){
                this._report_name_fixed.className = ""
                this.saveReport(report_name_fixed, days_fixed_report, action);
            }else{
                message.error("Add a report name", 5)
            }
        }else{
            let _msg_validation = "", 
                _validate = true, 
                _emails_tags = this.state.tags,
                _message_email = this.state.message_email,
                _dashboards_select = this.state.dashboards_select,
                _availably_days = this.state.availably_days,
                _dinamyc_report = this.state.dinamyc_report;

            message.destroy();
            if(_emails_tags.length === 0){
                _validate = false
                message.error("Add an email to share report", 5)
            }
            if(_message_email === ""){
                _validate = false
                message.error("Add a short message", 5)
            }
            if(Object.keys(_dashboards_select).length === 0){
                _validate = false
                message.error("Select the dashboards includes in report",5)
            }
            if(_validate){
                this.shareReport(_emails_tags, _message_email, _dashboards_select, _availably_days, _dinamyc_report)
            }
        }
    }
    shareReport(_emails_tags, _message_email, _dashboards_select, _availably_days, _dinamyc_report){

        let self = this, CancelToken = axios.CancelToken, qs = require("qs");
        let params = { 
            mails_tags : _emails_tags, 
            message_email : _message_email,
            dashboards_select : _dashboards_select,
            availably_days : _availably_days,
            dinamyc_report : _dinamyc_report,
            report_id : self.props.app.state.report_context._id
        };
        self.setState({
            request_loading : {
                window : "",
                before : "",
                after : "hide"
            }
        }, function(){
            axios({
                method : "POST",
                headers: { 'content-type' : 'application/x-www-form-urlencoded' },
                url : postUrlWidgets + "/share", 
                data : qs.stringify(self.props.app.newRequestPost(params)),
                cancelToken : new CancelToken(function executor(c) {
                self.state.main_request_token_cancel = c;
                })
            }).then(function(response) {
                self.setState({
                    request_loading : {
                        window : "",
                        before : "hide",
                        after : ""
                    }
                }, function(){
                    setTimeout(() => {
                        self.setState({
                            _report_name_fixed : "",
                            request_loading : {
                                window : "hide",
                                before : "hide",
                                after : "hide"
                            }
                        }, function(){
                            
                            self.handleClick("reports-new")
                            this.completeReport({ _msg : 'The report has been completed.'});
                        })
                    }, 500);  
                })
            });
        })   
    }
    saveReport(name_report, days_fixed_report, action = '_save_edit'){
        let self = this, CancelToken = axios.CancelToken, qs = require("qs");
        let params = { 
            name : name_report, 
            notify_email : self.state.notify_email,
            startValue :  self.state.startValue.format('YYYY-MM-DD HH:mm:ss'),
            endValue :  self.state.endValue.format('YYYY-MM-DD HH:mm:ss'),
            days_fixed_report : days_fixed_report,
            type_report : self.state._type_report,
            analysis_interval : self.state._analysis_interval,
            allow_export : self.state._allow_export
        };
        if(self.isEdit(self.props.app._widgetSidebar)){
            params.update = true;
            params._id = self.props.app.state.report_context._id;
        }
        
        self.setState({
            request_loading : {
                window : "",
                before : "",
                after : "hide"
            }
        }, function(){
            axios({
                method : "POST",
                headers: { 'content-type' : 'application/x-www-form-urlencoded' },
                url : postUrlWidgets + "/add", 
                data : qs.stringify(self.props.currentFilters(params)),
                cancelToken : new CancelToken(function executor(c) {
                self.state.main_request_token_cancel = c;
                })
            }).then(function(response) {
                self.setState({
                    request_loading : {
                        window : "",
                        before : "hide",
                        after : ""
                    }
                }, function(){
                    setTimeout(() => {
                        self.setState({
                            _report_name_fixed : "",
                            request_loading : {
                                window : "hide",
                                before : "hide",
                                after : "hide"
                            }
                        }, function(){
                            if(action === '_save_edit'){
                                self.handleClick("reports-new")
                                self.completeReport(response.data);
                            }else if(action === '_save_share'){
                                self.setShareModal(response.data['_data']);
                            }
                        })
                    }, 500);  
                })
            });
        })
        
    }
    isEdit(obj){
        if(obj === undefined || obj === null){
            return false
        }else{
            return obj.state._report.edit;
        }
    }
    componentWillReceiveProps() {
        let rows_models = [], rows_reports = [];
        for (let index = 0; index < 10; index++) {
            rows_models[index] = (
                <div className={"row-list " + (index % 2 ? "row-c" : "")}>
                    <div>lorem impusns sadas </div>
                    <div>
                        <a className="apply">Apply</a>
                        <a className="share">Share</a>
                        <a className="remove">Delete</a>
                    </div>
                </div>
            );
            rows_reports[index] = (
                <div className={"row-list " + (index % 2 ? "row-c" : "")}>
                    <div>lorem impusns sadass</div>
                    <div>
                        <a className="apply">Apply</a>
                        <a className="share">Share</a>
                        <a className="remove">Delete</a>
                    </div>
                </div>
            );
        }

        this.setState({
            rows_models: rows_models,
            rows_reports: rows_reports
        })
    }

    componentDidMount(){
        let day     = new Date();
        let year    = day.getFullYear();

        this.setState({ 
            month_select        : new Date(year, day.getMonth()),
            from_month_current  : new Date(year, day.getMonth()),
        })
    }
    completeReport(response){
        this.props.app._widgetSidebar.setState({
            _report : {
                active : false,
                edit : false,
                share : false
            }
        }, function(){
            this.props.app.setState({
                report_context : {
                    status : false,
                    className : "",
                    name : "",
                    type_report : "",
                    notify_email : 0,
                    allow_export : 0,
                    startValue : null,
                    endValue : null,
                    days_fixed_report : ""
                }
            }, function(){
                    message.info(response._msg);
            })
        })
    }
    render() {
        const { Option, OptGroup } = Select, 
            panels_props = this.state.panels,
            RadioGroup = Radio.Group, 
            { TextArea } = Input,
            self = this;
        const { startValue, endValue, endOpen } = this.state;
            const listReports = Object.keys(panels_props).map((key) => {
                const panel = panels_props[key].name;
                let dashboards = panels_props[key].dashboards;

                return (
                    <OptGroup key={panel}>
                        {
                            Object.keys(dashboards).map(function(key_dashboard){
                                let _value_dashboard = dashboards[key_dashboard];
                                return (
                                    <Option 
                                        key={(
                                            '{' +
                                                '"_dashboard":"' + _value_dashboard.value + '",' +
                                                '"_panel":"' + panel+'",' +
                                                '"_index":"' + _value_dashboard.index + '",' +
                                                '"_params_module":' + _value_dashboard.params_module + 
                                            '}' 
                                            
                                        )}
                                        children={_value_dashboard.name}
                                    />
                                )
                            })
                        }                    
                    </OptGroup>
                )
            })
        /*const listReports = Object.keys(panels_props).map(function(key){
            const _panel = panels_props[key]._value;
            return (
                <OptGroup key={panels_props[key]['_name']}>
                    {
                        Object.keys(panels_props[key].dashboards).map(function(key_dashboard){
                            let _value_dashboard = panels[key].dashboards[key_dashboard];
                            return (
                                <Option 
                                    key={(
                                        '{' +
                                            '"_dashboard":"'+ _value_dashboard._value +'",' +
                                            '"_panel":"'+_panel+'",' +
                                            '"_index":"'+_value_dashboard._index+'",' +
                                            '"_params_module":' +_value_dashboard._params_module + 
                                        '}' 
                                         
                                    )}
                                    children={_value_dashboard._name}
                                />
                            )
                        })
                    }                    
                </OptGroup>
            )
        })*/
        return (
            <Drawer
                title={ (function(){ 
                    if(self.props.app._widgetSidebar === undefined || self.props.app._widgetSidebar === null){
                        return "SAVE REPORT"
                    } else if(self.props.app._widgetSidebar.state._report.edit === true){
                        return "UPDATE REPORT";
                    }else if(self.props.app._widgetSidebar.state._report.share === false){
                        return "SAVE REPORT";
                    }else{
                        return "SHARE REPORT"
                    }
                })()}
                placement="right"
                closable={false}
                onClose={this.handleClick.bind(this, "reports-new")}
                visible={this.props.alert_modal_report_new}
                maskClosable={false}
                height={'100%'}
                width={420}
                ref={(child) => { this._DrawerDialog = child; }} 
                destroyOnClose={true}
            > 
                <div className={"alert-models-modal form-new "}>
                    <div className="container-list">
                        <div className={"request-loading " + this.state.request_loading.window }>
                            <Icon type="loading" theme="outlined" className={this.state.request_loading.before } />
                            <p className={this.state.request_loading.after }>
                                <Icon type="check-circle" theme="twoTone" />
                                The report has been saved
                            </p>
                        </div>
                        <div className={"step-1 " + (this.state.step_active !== "1" ? "hide" : "")}>
                            { (this.isEdit(this.props.app._widgetSidebar) === false) ?    
                                (<div>
                                    {/*<h4 className="data-title">
                                        CHOOSE HOW YOU'D LIKE TO SAVE YOUR REPORT
                                    </h4>
                                    <div className="types-report">
                                        <a className={this.state._type_report === "FIXED" ? "active" : ""} onClick={this.activeReport.bind(this, "FIXED", true)}>FIXED REPORT</a> 
                                            <span className="space-button">or</span>
                                        <a className={this.state._type_report === "DYNAMIC" ? "active" : ""} onClick={this.activeReport.bind(this, "DYNAMIC", true)}>DYNAMIC REPORT</a> 
                                    </div>*/ }
                                </div>) : ""
                            }
                            <div className={"data-report " + (this.state._type_report === "" ? "hide" : "")}>
                                <div>
                                    <h4 className="data-title">
                                        REPORT INFORMATION
                                    </h4>
                                    <Input 
                                        type="text" 
                                        className="ant-input"
                                        value={this.state._report_name_fixed}
                                        onChange={(event) => {
                                            this.setState({
                                                _report_name_fixed : event.target.value
                                            })
                                        }}
                                        ref={(child) => { this._report_name_fixed = child; }} 
                                        placeholder="Report Name" />
                                </div>
                                <div className="notify-email">
                                    <p>Allow export of reports?</p>
                                    <RadioGroup 
                                        disabled={(this.isEdit(this.props.app._widgetSidebar) ? true : false)}
                                        onChange={(event) => {
                                            this.setState({
                                                _allow_export : event.target.value
                                            })
                                        }} 
                                        value={this.state._allow_export}>
                                            <Radio value={1}>Yes</Radio>
                                            <Radio value={0}>No</Radio>
                                    </RadioGroup>
                                </div>
                                <div className={"two-colums " + (this.state._type_report !== "DYNAMIC" ? "hide" : "")}>
                                    <div className="">
                                        <span>Analysis interval (days)</span>
                                    </div>
                                    <div className="">
                                        <Input 
                                            type="number" 
                                            min="1"
                                            placeholder="Days"
                                            value={this.state._analysis_interval}
                                            onChange={(event) => {
                                                this.setState({
                                                    _analysis_interval : event.target.value
                                                })
                                            }} />
                                    </div>
                                </div>
                                <div className="notify-email">
                                    <p>Would you like to receive this report by email?</p>
                                    <RadioGroup 
                                        disabled={(this.isEdit(this.props.app._widgetSidebar) ? true : false)}
                                        onChange={(event) => {
                                            this.setState({
                                                notify_email : event.target.value
                                            })
                                        }} 
                                        value={this.state.notify_email}>
                                            <Radio value={1}>Yes</Radio>
                                            <Radio value={0}>No</Radio>
                                    </RadioGroup>
                                </div>
                                <div className={"two-colums " + (this.state.notify_email === 0 ? "hide" : "")}>
                                    <div className="">
                                        <span>Shipping interval (days)</span>
                                    </div>
                                    <div className="">
                                        <Input 
                                            type="number" 
                                            min="1"
                                            placeholder="Days" 
                                            className="ant-input interval-days" 
                                            name="interval_analysis" 
                                            value={this.state._days_fixed_report}
                                            onChange={(event) => {
                                                this.setState({
                                                    _days_fixed_report : event.target.value
                                                })
                                            }}
                                            ref={(child) => { this._days_fixed_report = child; }} 
                                            disabled={(this.isEdit(this.props.app._widgetSidebar) ? true : false)}
                                            />
                                    </div>
                                </div>
                                {/*<div className={"two-colums " + (this.state.notify_email === 0 ? "hide" : "")}>
                                    <div className="">
                                        <span>When would you like this report to begin?</span>
                                    </div>
                                    <div className="datepicker-wdg">
                                        <DatePicker 
                                            defaultValue={ moment(this.state.datepicker, 'YYYY-MM-DD HH:mm:ss')}
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            locale={locale}
                                            onChange={(moment_date, date)=> {
                                                this.setState({
                                                    datepicker : date
                                                })
                                            }}
                                        />
                                    </div>
                                        </div> */}
                                <div className={"notify-email " + (this.state.notify_email === 0 ? "hide" : "")}>
                                    <div className="">
                                        <p>When would you like this report to start/end?</p>
                                    </div>
                                    <div className="datepicker-wdg">
                                        <p style={{marginTop : 15, marginBottom : 5}}>Start Date</p>
                                        <DatePicker
                                            disabledDate={this.disabledStartDate}
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            value={startValue}
                                            placeholder="Select Date"
                                            onChange={this.onStartChange}
                                            onOpenChange={this.handleStartOpenChange}
                                            style={{width : '100%'}}
                                            readonly
                                            disabled={(this.isEdit(this.props.app._widgetSidebar) ? true : false)}
                                        />
                                        <p style={{marginTop : 15, marginBottom : 5}}>End Date</p>
                                        <DatePicker
                                            disabledDate={this.disabledEndDate}
                                            showTime
                                            format="YYYY-MM-DD HH:mm:ss"
                                            value={endValue}
                                            placeholder="Select Date"
                                            onChange={this.onEndChange}
                                            open={endOpen}
                                            onOpenChange={this.handleEndOpenChange}
                                            style={{marginTop : 5, width : '100%'}}
                                            readonly
                                            disabled={(this.isEdit(this.props.app._widgetSidebar) ? true : false)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"step-2 " + (this.state.step_active !== "2" ? "hide" : "")}>
                            <p>Report: <strong>{(this.props.app.state.report_context !== undefined) ? this.props.app.state.report_context.name : ""}</strong></p>
                            <p>Share a link to this report with the following emails: *</p>
                            <div className="emails-share">
                                <TagsInput 
                                    value={this.state.tags} 
                                    onChange={(tags) => {
                                        const email = localStorage.getItem('email')
                                        if(tags.indexOf(email) === -1){
                                            this.setState({tags})
                                        }else{
                                            message.info('Cannot add your email account')
                                        }
                                    }}
                                    validationRegex={ /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/}
                                    inputProps={{
                                        placeholder : 'Add email',
                                        className : "ant-input inputEmailAdd"
                                    }} 
                                    ref={(child) => { this._tags_email = child; }}/>
                            </div>
                            <p>Include a short message *</p>
                            <TextArea 
                                rows={5}
                                placeholder="Enter a personalized message for your contacts." 
                                value={this.state.message_email}
                                onChange={(event) => {
                                    this.setState({
                                        message_email : event.target.value
                                    })
                                }}
                            />
                            <div className="two-colums ">
                                <p>Dashboards included in this report: *</p>
                                <Select
                                    mode="tags"
                                    size={'default'}
                                    placeholder="Please select"
                                    style={{ width: '100%', display : 'block' }}
                                    children={listReports}
                                    value={this.state.dashboards_select}
                                    onChange={(value) => {
                                        this.setState({
                                            dashboards_select : value
                                        })
                                    }}
                                    onDeselect={(value) => {
                                        this.setState({
                                            dashboards_select : value
                                        })
                                    }}
                                />
                            </div>
                            <div className="two-colums">
                                <div className="">
                                    <p>Availability of the report (days): * </p>
                                </div>
                                <div className="">
                                    <Input 
                                        type="number"
                                        placeholder="Days"
                                        value={this.state.availably_days}
                                        onChange={(event) => {
                                            this.setState({
                                                availably_days : event.target.value
                                            });
                                        }}
                                        min="1"
                                        max="31" />
                                </div>
                            </div>
                            <div className="two-colums hide">
                                <div className="">
                                    <span>Report interaction</span>
                                    {/*<span className="more-info-report">?</span>*/}
                                </div>
                                <div>
                                    <RadioGroup 
                                        onChange={(e) => {
                                            this.setState({ dinamyc_report: e.target.value })
                                        }} 
                                        value={this.state.dinamyc_report}>
                                        <Radio value={1}>Yes</Radio>
                                        <Radio value={0}>No</Radio>
                                    </RadioGroup>
                                </div>
                            </div>
                        </div>
                        <div className={"step-3 " + (this.state.step_active !== "3" ? "hide" : "")}>
                            <p>Report: <strong>{(this.props.app.state.report_context !== undefined) ? this.props.app.state.report_context.name : ""}</strong></p>
                            <p>People with access to reports or to those that have been shared.</p>
                            <table>
                                <tr>
                                    <th>Email</th>
                                    <th>Shipping date</th>
                                    <th>State</th>
                                    <th></th>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Valid</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Valid</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                                <tr>
                                    <td>correo1@ejemplo.com</td>
                                    <td>29/MAY/2018</td>
                                    <td>Valid</td>
                                    <td>
                                        <a className="opt-email"></a>
                                        <a className="opt-email"></a>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className="footer-actions">
                            <div className="row">
                                <div className="col-md-12"> 
                                    <Button 
                                        type="primary" 
                                        size="default" 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 10, 
                                            letterSpacing : 1, 
                                            width : '100%',
                                            color : '#FFFFFF'
                                        }} 
                                        className={this.state.shareBtnState + " "+ (this.state._type_report === "" ? "hide" : "")}
                                        onClick={this.actionReport.bind(this, '_save_share')}
                                        children={ (this.isEdit(this.props.app._widgetSidebar) === true) ? "UPDATE & SHARE" : "SAVE & SHARE" } />
                                    
                                    <Button 
                                        type="primary" 
                                        size="default" 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 10, 
                                            letterSpacing : 1, 
                                            width : '100%',
                                            color : '#FFFFFF'
                                        }} 
                                        className={this.state.saveBtnState + " "+ (this.state._type_report === "" ? "hide" : "")}
                                        onClick={this.actionReport.bind(this, '_save_edit')}
                                        children={ (this.isEdit(this.props.app._widgetSidebar) === true) ? "UPDATE" : "SAVE" } />

                                    <Button 
                                        type="primary" 
                                        size="default" 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 10, 
                                            letterSpacing : 1, 
                                            width : '100%',
                                            color : '#FFFFFF'
                                        }} 
                                        className={this.state.completeBtnState + " "+ (this.state._type_report === "" ? "hide" : "")}
                                        onClick={this.actionReport.bind(this, '_complete_share')}
                                        children={"COMPLETE"} />

                                    <Button 
                                        type="default" 
                                        size="default" 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 20, 
                                            letterSpacing : 1, 
                                            width : '100%',
                                        }} 
                                        className={this.state.completeBtnState + " " + (this.state._type_report === "" ? "hide" : "")}
                                        onClick={this.skipStep.bind(this)}
                                        children={"SKIP STEP"} />

                                    <Button 
                                        type="default" 
                                        size="default" 
                                        style={{ 
                                            fontSize : 12, 
                                            marginTop : 20, 
                                            letterSpacing : 1, 
                                            width : '100%',
                                        }} 
                                        className={this.state.saveBtnState + " " + (this.state._type_report === "" ? "hide" : "")}
                                        onClick={() => {
                                            this.props.reportModelState('reports-new')
                                        }}
                                        children={"CONTINUE EDITING"} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Drawer>
        )
    }
}

export default ReportModel


// WEBPACK FOOTER //
// ./src/Frontend/reports/ReportModel.js